import { IconButton } from "@mui/material"
import { usePreviousAlbum } from "../../hooks/player/usePreviousAlbum"
import { KeyboardArrowLeft, KeyboardArrowRight, KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight, Pause, PlayArrow } from "@mui/icons-material"
import { usePreviousSong } from "../../hooks/player/usePreviousSong"
import { useNextSong } from "../../hooks/player/useNextSong"
import { useNextAlbum } from "../../hooks/player/useNextAlbum"
import { useSelector } from "react-redux"
import { useResumePause } from "../../hooks/player/useResumePause"
import { anyPlaybackState, isPlaying } from "../../reducers/playbackState"
import { anyPointedDevice } from "../../reducers/devices"
import { getRandomModeActive } from "../../reducers/randomMode"
import { anyDisablingProcess } from "../../reducers/disablingProcesses"

export const PreviousAlbumButton = ({size}) => {
    const pointedDevice = useSelector(anyPointedDevice);
    const playbackState = useSelector(anyPlaybackState);
    const randomModeActive = useSelector(getRandomModeActive);
    const disabled = useSelector(anyDisablingProcess) || !pointedDevice || !playbackState || !randomModeActive;

    return (
        <IconButton disabled={disabled} onClick={usePreviousAlbum()} size={size}>
            <KeyboardDoubleArrowLeft fontSize={size} />
        </IconButton>
    )
}

export const PreviousSongButton = ({size}) => {
    const pointedDevice = useSelector(anyPointedDevice);
    const playbackState = useSelector(anyPlaybackState);
    const disabled = useSelector(anyDisablingProcess) || !pointedDevice || !playbackState;

    return (
        <IconButton disabled={disabled} onClick={usePreviousSong()} size={size}>
            <KeyboardArrowLeft fontSize={size} />
        </IconButton>
    )
}

export const NextSongButton = ({size}) => {
    const pointedDevice = useSelector(anyPointedDevice);
    const playbackState = useSelector(anyPlaybackState);
    const disabled = useSelector(anyDisablingProcess) || !pointedDevice || !playbackState;

    return (
        <IconButton disabled={disabled} onClick={useNextSong()} size={size}>
            <KeyboardArrowRight fontSize={size} />
        </IconButton>
    )
}

export const NextAlbumButton = ({size}) => {
    const pointedDevice = useSelector(anyPointedDevice);
    const playbackState = useSelector(anyPlaybackState);
    const randomModeActive = useSelector(getRandomModeActive);
    const disabled = useSelector(anyDisablingProcess) || !pointedDevice || !playbackState || !randomModeActive;

    return (
        <IconButton disabled={disabled} onClick={useNextAlbum()} size={size}>
            <KeyboardDoubleArrowRight fontSize={size} />
        </IconButton>
    )
}

export const PlayPauseButton = ({size}) => {
    const playing = useSelector(isPlaying);

    const pointedDevice = useSelector(anyPointedDevice);
    const playbackState = useSelector(anyPlaybackState);
    const disabled = useSelector(anyDisablingProcess) || !pointedDevice || !playbackState;

    return (
        <IconButton disabled={disabled} onClick={useResumePause(playing)} size={size}>
            {
                playing ? <Pause fontSize={size} /> : <PlayArrow fontSize={size} />
            }
        </IconButton>
    )
}